export default import.meta.ROLLDOWN_FILE_URL_zVUk_8$8tBc3ydqwFyM8VA